import React, { useState, useEffect, useRef, useContext } from "react";
import { Paginator } from "primereact/paginator";
import {
  getReimbursementList,
  postReimbursementAddUpdate,
  postReimbursementDelete as deleteReimbursementAPI,
} from "./Services/PayrollService";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { TostMsg } from "../../../App";

const ReimbursementManagement = () => {
  const [reimbursementManagementSummery, setReimbursementManagementSummery] =
    useState([]);
  const [reimbursementManagementList, setReimbursementManagementList] =
    useState([]);
  const [reimbursementStatusList, setReimbursementStatusList] = useState([]);
  const [reimbursementTypeList, setReimbursementTypeList] = useState([]);
  const [EmployeeList, setEmployeeList] = useState([]);
  const [formonthList, setFormonthList] = useState([]);
  const [arrears, setArrears] = useState([]);
  const [reimbs, setReimbs] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const searchTimeout = useRef(null);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toaster = useContext(TostMsg);

  useEffect(() => {
    getMasterData();
    GetEmployeeList();
  }, []);

  const GetEmployeeList = async () => {
    let params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EpmId,
      IsDirectReportOrHierarchy: 0,
      EmployeeId: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsSuggestedOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
    };
    try {
      let res = await getEmployeeList(params);
      setEmployeeList(res.Data);
    } catch (error) {
      console.error("Error fetching employee list:", error);
    }
  };

  const getMasterData = async () => {
    try {
      // setIsloading(true);

      const statusParams = {
        masterType: "ReimbusementStatus",
        allRecords: true,
        organisationId: userDetails?.OrgId,
      };

      const typeParams = {
        masterType: "ReimbursementTypes",
        allRecords: true,
        organisationId: userDetails?.OrgId,
      };

      const formonthParams = {
        masterType: "formonth",
        allRecords: true,
        organisationId: userDetails?.OrgId,
      };

      const [statusRes, typeResm, formonthRes] = await Promise.all([
        GetMasterTypeData(statusParams),
        GetMasterTypeData(typeParams),
        GetMasterTypeData(formonthParams),
      ]);

      setReimbursementStatusList(statusRes?.Data || []);
      setReimbursementTypeList(typeResm?.Data || []);
      setFormonthList(formonthRes?.Data || []);
    } catch (error) {
      // toster.current.error(ERROR_LIST?.MasterDataType);
    } finally {
      // setIsloading(false);
    }
  };

  const GetReimbursementList = async (page = 1, size = rows) => {
    // const typeData = reimbursementTypeList?.find(t => t.Name === filterType);
    // const monthData = formonthList?.find(m => m.Name === filterMonth);

    let params = {
      ReimbursementId: 0,
      LoggedInEmpId: 0,
      OrgId: userDetails?.OrgId,
      GUID: "",
      EmpId: 0,
      PageNumber: page,
      PageSize: size,
      Search: searchQuery || "",
      ReimbursementStatusId: filterMonth || "",
      ReimbursementTypeId: filterType || "",
    };
    try {
      let res = await getReimbursementList(params);
      setReimbursementManagementSummery(res?.Data?.ReimbursementSummary[0]);
      setReimbs(res?.Data?.ReimbursementItems || []);
      setTotalRecords(
        res?.Data?.RecordCount ||
          res?.Data?.TotalRecords ||
          res?.Data?.TotalCount ||
          res?.Data?.ReimbursementItems?.length ||
          0,
      );
    } catch (error) {
      console.error("Error fetching reimbursement list:", error);
    }
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    const page = event.first / event.rows + 1;
    GetReimbursementList(page, event.rows);
  };

  const PostReimbursementAddUpdate = async (params) => {
    try {
      let res = await postReimbursementAddUpdate(params);
      if (res?.StatusCode === 2000) {
        toaster.current.success(
          `Reimbursement ${params.Id ? "updated" : "added"} successfully`,
        );
        GetReimbursementList(1, rows);
        setFirst(0);
        return { success: true };
      } else {
        toaster.current.error(
          res?.Message || "Error saving reimbursement. Please try again.",
        );

        return {
          success: false,
          error:
            res?.Message || "Error saving reimbursement. Please try again.",
        };
      }
    } catch (error) {
      console.error("Error saving reimbursement:", error);
      toaster.current.error("Error saving reimbursement. Please try again.");
      return {
        success: false,
        error: error.message || "Error saving reimbursement",
      };
    }
  };

  const postReimbursementDelete = async (params) => {
    try {
      let res = await deleteReimbursementAPI(params);
      console.log("Delete API Response:", res);
      if (res?.StatusCode === 2000) {
        toaster.current.success("Reimbursement deleted successfully");
        return { success: true };
      } else {
        console.error("Delete API Error:", res?.Message || "Unknown error");
        toaster.current.error(
          "Error deleting reimbursement. Please try again.",
        );
        return {
          success: false,
          error:
            res?.Message || "Error deleting reimbursement. Please try again.",
        };
      }
    } catch (error) {
      console.error("Error deleting reimbursement:", error);
      toaster.current.error("Error deleting reimbursement. Please try again.");
      return {
        success: false,
        error: error.message || "Error deleting reimbursement",
      };
    }
  };

  const [nextId, setNextId] = useState(10);
  const [editId, setEditId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteRecord, setDeleteRecord] = useState(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterMonth, setFilterMonth] = useState("");

  useEffect(() => {
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      GetReimbursementList(1, rows);
      setFirst(0);
    }, 500);
    return () => clearTimeout(searchTimeout.current);
  }, [searchQuery, filterType, filterMonth]);

  const [formData, setFormData] = useState({
    EmployeeName: "",
    ReimbursementTypeName: "",
    amount: "",
    ForMonth: "March 2025",
    Desc: "",
  });

  // Format amount in Indian Rupees
  const rup = (n) => (n ? `₹${n.toLocaleString("en-IN")}` : "—");

  // Type badge class
  const typeBadge = (t) => {
    const badges = {
      Meal: "badge-meal",
      Fuel: "badge-fuel",
      Mobile: "badge-mobile",
      Internet: "badge-internet",
      LTA: "badge-lta",
    };
    return badges[t] || "badge-other";
  };

  // Server-side filtering — reimbs already contains the filtered page
  const totalAmount = reimbs.reduce((sum, r) => sum + (r.Amount || 0), 0);
  const mealTotal = reimbs
    .filter((r) => r.ReimbursementTypeName === "Meal")
    .reduce((sum, r) => sum + r.Amount, 0);
  const fuelTotal = reimbs
    .filter((r) => r.ReimbursementTypeName === "Fuel")
    .reduce((sum, r) => sum + r.Amount, 0);
  const ltaTotal = reimbs
    .filter((r) => r.ReimbursementTypeName === "LTA")
    .reduce((sum, r) => sum + r.Amount, 0);

  // Open Add Form
  const openAdd = () => {
    setEditId(null);
    setFormData({
      EmployeeName: "",
      ReimbursementTypeName: "",
      amount: "",
      ForMonth: "March 2025",
      Desc: "",
    });
    setShowModal(true);
  };

  // Open Edit Form
  const openEdit = (Id) => {
    const record = reimbs.find((r) => r.Id === Id);
    if (!record) return;

    setEditId(Id);
    setFormData({
      EmployeeName: `${record.EmployeeName}|${record.EmpId}`,
      ReimbursementTypeName: record.ReimbursementTypeName,
      amount: record.Amount.toString(),
      ForMonth: record.ForMonth,
      Desc: record.Desc || "",
    });
    setShowModal(true);
  };

  // Save Claim (Add or Edit)
  const saveReimb = async () => {
    const { EmployeeName, ReimbursementTypeName, amount, ForMonth, Desc } =
      formData;
    const Amount = parseFloat(amount) || 0;

    if (!EmployeeName || !ReimbursementTypeName || !Amount || !ForMonth) {
      console.log("Please fill all required fields.");
      return;
    }

    const [empName, EmpId] = EmployeeName.includes("|")
      ? EmployeeName.split("|")
      : [EmployeeName, ""];

    // Find the reimbursement type ID
    const typeData = reimbursementTypeList?.find(
      (t) => t.Name === ReimbursementTypeName,
    );
    const typeId = typeData?.Id || 0;

    // Find the employee data
    const employeeData = EmployeeList?.find((e) => e.EmploymentId === EmpId);
    const empEmpId = employeeData?.EmpId || 0;

    // Prepare params for API
    let params = {
      Id: editId || 0,
      OrgId: userDetails?.OrgId || 0,
      EmpId: empEmpId,
      ReimbursementTypeId: typeId,
      Amount: Amount,
      Desc: Desc || "",
      ForMonth: ForMonth || "",
    };

    // Call API
    const result = await PostReimbursementAddUpdate(params);

    if (result.success) {
      setShowModal(false);
    } else {
      console.log(result.error || "Error saving reimbursement");
    }
  };

  // Ask for Delete Confirmation
  const askDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  // Confirm Delete
  const confirmDelete = async () => {
    const params = {
      RequestId: deleteId,
      // UserId: userDetails?.EmpId,
    };
    try {
      const result = await postReimbursementDelete(params);
      if (result?.StatusCode === 2000) {
        setShowDeleteModal(false);
        setDeleteRecord(null);
        setDeleteId(null);
        await GetReimbursementList(1, rows);
        setFirst(0);
      } else {
        console.error("Delete error:", result.error);
      }
    } catch (error) {}
  };

  const handleExport = () => {
    if (!reimbs.length) {
      console.log("No data to export");
      return;
    }

    const headers = [
      "Employee",
      "Employee ID",
      "Type",
      "Month",
      "Amount",
      "Description",
    ];

    const csvRows = reimbs.map((r) => [
      r.EmployeeName,
      r.EmpId,
      r.ReimbursementTypeName,
      r.ForMonth,
      r.Amount,
      r.Desc,
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...csvRows].map((e) => e.join(",")).join("\n");

    const link = document.createElement("a");
    link.href = encodeURI(csvContent);
    link.download = "reimbursements.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="container-fluid">
      {/* Main Content */}
      <div className="form-head d-flex flex-wrap align-items-center page-head mb-0">
        <div className="me-auto">
          <h2 className="font-w600 mb-0">Reimbursement Management</h2>
          <p>
            {" "}
            Employee reimbursement claims — Meal, Fuel, Mobile, Internet, LTA,
            Books &amp; Education. Approved claims flow into payroll Step 6.
          </p>
        </div>
        <div className="rightside-tabs">
          <div className="topbar-actions">
            <button
              className="btn-og btn-og-secondary btn-og-sm"
              onClick={handleExport}
            >
              <i className="pi pi-file-excel"></i> Export
            </button>
            <button className="btn-og theme-color btn-og-sm" onClick={openAdd}>
              <i className="pi pi-plus" style={{ fontSize: "12px" }}></i> Add
              Claim
            </button>
          </div>
        </div>
      </div>

      <div className="page-content">
        {/* Summary Cards */}
        <div className="rem-summary-grid">
          <div className="rem-summary-card">
            <div className="rem-summary-label">Total Claims</div>
            <div className="rem-summary-value" Id="sum-count">
              {totalRecords}
            </div>
          </div>
          <div className="rem-summary-card">
            <div className="rem-summary-label">This Month Total</div>
            <div className="rem-summary-value">{rup(totalAmount)}</div>
          </div>
          <div className="rem-summary-card">
            <div className="rem-summary-label">Meal</div>
            <div className="rem-summary-value">{rup(mealTotal)}</div>
          </div>
          <div className="rem-summary-card">
            <div className="rem-summary-label">Fuel / Travel</div>
            <div className="rem-summary-value">{rup(fuelTotal)}</div>
          </div>
          <div className="rem-summary-card">
            <div className="rem-summary-label">LTA Claims</div>
            <div className="rem-summary-value">{rup(ltaTotal)}</div>
          </div>
        </div>

        {/* Table Card */}
        <div className="card" style={{ overflow: "hidden" }}>
          <div className="toolbar">
            <input
              ReimbursementTypeName="text"
              className="form-control"
              placeholder="Search employee…"
              style={{ width: "200px" }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <div className="toolbar-sep"></div>

            <select
              className="form-select"
              style={{ width: "160px" }}
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
            >
              <option value="">All Types</option>
              {reimbursementTypeList.map((t) => (
                <option key={t.Id} value={t.Id}>
                  {t.Name}
                </option>
              ))}
            </select>

            <select
              className="form-select"
              style={{ width: "130px" }}
              value={filterMonth}
              onChange={(e) => setFilterMonth(e.target.value)}
            >
              <option value="">All Months</option>
              {formonthList.map((m) => (
                <option key={m.Id} value={m.Id}>
                  {m.Name}
                </option>
              ))}
            </select>

            <div className="toolbar-spacer"></div>
            <span style={{ fontSize: "12px", color: "var(--text-muted)" }}>
              {totalRecords} claims
            </span>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table className="mgmt-tbl">
              <thead>
                <tr>
                  <th>Employee</th>
                  <th>Type</th>
                  <th>Description</th>
                  <th>Month</th>
                  <th className="tr">Amount</th>
                  <th style={{ textAlign: "center" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {reimbs.length === 0 ? (
                  <tr>
                    <td
                      colSpan="6"
                      style={{
                        textAlign: "center",
                        padding: "32px",
                        color: "var(--text-muted)",
                      }}
                    >
                      No records found
                    </td>
                  </tr>
                ) : (
                  reimbs.map((r) => (
                    <tr key={r.Id}>
                      <td>
                        <span style={{ fontWeight: 600 }}>
                          {r.EmployeeName}
                        </span>
                        <br />
                        <code
                          style={{ fontSize: "10px", color: "var(--brand)" }}
                        >
                          {r.EmpId}
                        </code>
                      </td>
                      <td>
                        <span
                          className={`badge ${typeBadge(r.ReimbursementTypeName)}`}
                          style={{ fontSize: "10.5px" }}
                        >
                          {r.ReimbursementTypeName}
                        </span>
                      </td>
                      <td
                        style={{ fontSize: "12px", color: "var(--text-muted)" }}
                      >
                        {r.Desc}
                      </td>
                      <td
                        style={{ fontSize: "12px", color: "var(--text-muted)" }}
                      >
                        {r.ForMonth}
                      </td>
                      <td className="tr" style={{ fontWeight: 700 }}>
                        {rup(r.Amount)}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <div
                          style={{
                            display: "flex",
                            gap: "4px",
                            justifyContent: "center",
                          }}
                        >
                          <button
                            className="btn btn-light btn-sm"
                            onClick={() => openEdit(r.Id)}
                            title="Edit"
                          >
                             <i className="fa-solid fa-pen"></i>
                          </button>
                          <button
                            className="btn btn-light btn-sm"
                            onClick={() => askDelete(r.Id)}
                            title="Delete"
                            style={{ color: "var(--danger)" }}
                          >
                            <i className="fa-solid fa-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="4">PAGE TOTAL</td>
                  <td className="tr" style={{ fontWeight: 700 }}>
                    {rup(totalAmount)}
                  </td>
                  <td>—</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <Paginator
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            rowsPerPageOptions={[10, 20, 50, 100]}
            onPageChange={onPageChange}
            template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          />
        </div>
      </div>
      {/* Add/Edit Modal */}
      {showModal && (
        <div className="mo open" onClick={() => setShowModal(false)}>
          <div className="mb" onClick={(e) => e.stopPropagation()}>
            <div className="mh">
              <div className="icon-div">
                <i className="pi pi-receipt" style={{ fontSize: "13px" }}></i>
              </div>
              <h6 style={{ margin: 0, fontSize: "14px", fontWeight: 700 }}>
                {editId ? "Edit Claim" : "Add Reimbursement Claim"}
              </h6>
              <button
                style={{
                  marginLeft: "auto",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#888",
                  lineHeight: 1,
                }}
                onClick={() => setShowModal(false)}
              >
                ×
              </button>
            </div>

            <div className="mbody">
              <div className="fsec">Employee &amp; Claim Details</div>
              <div className="fg2">
                <div>
                  <label className="form-label">
                    Employee <span style={{ color: "var(--danger)" }}>*</span>
                  </label>
                  <select
                    className="form-select w-100"
                    value={formData.EmployeeName}
                    onChange={(e) =>
                      setFormData({ ...formData, EmployeeName: e.target.value })
                    }
                  >
                    <option value="">Select…</option>
                    {EmployeeList.map((employee) => (
                      <option
                        key={employee.Id}
                        value={`${employee.FullName}|${employee.EmploymentId}`}
                      >
                        {employee.FullName} ({employee.EmploymentId})
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="form-label">
                    Reimbursement Type{" "}
                    <span style={{ color: "var(--danger)" }}>*</span>
                  </label>
                  <select
                    className="form-select w-100"
                    value={formData.ReimbursementTypeName}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        ReimbursementTypeName: e.target.value,
                      })
                    }
                  >
                    <option value="">Select…</option>
                    {reimbursementTypeList.map((t) => (
                      <option key={t.Id} value={t.Name}>
                        {t.Name}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="form-label">
                    Amount (₹) <span style={{ color: "var(--danger)" }}>*</span>
                  </label>
                  <input
                    ReimbursementTypeName="number"
                    className="form-control w-100"
                    placeholder="0"
                    value={formData.amount}
                    onChange={(e) =>
                      setFormData({ ...formData, amount: e.target.value })
                    }
                  />
                </div>

                <div>
                  <label className="form-label">
                    For Month <span style={{ color: "var(--danger)" }}>*</span>
                  </label>
                  <select
                    className="form-select w-100"
                    value={formData.ForMonth}
                    onChange={(e) =>
                      setFormData({ ...formData, ForMonth: e.target.value })
                    }
                  >
                    {formonthList.map((m) => (
                      <option key={m.Id} value={m.Name}>
                        {m.Name}
                      </option>
                    ))}
                  </select>
                </div>

                <div style={{ gridColumn: "1 / -1" }}>
                  <label className="form-label">Description / Notes</label>
                  <input
                    ReimbursementTypeName="text"
                    className="form-control w-100"
                    placeholder="e.g. Monthly meal, client travel, LTA claim…"
                    value={formData.Desc}
                    onChange={(e) =>
                      setFormData({ ...formData, Desc: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="mfoot">
              <button
                className="btn btn-light"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button className="btn btn-brand" onClick={saveReimb}>
                <i className="pi pi-check"></i>{" "}
                {editId ? "Save Changes" : "Add Claim"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="mo open" onClick={() => setShowDeleteModal(false)}>
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              width: "400px",
              padding: "24px",
              boxShadow: "0 24px 64px rgba(0,0,0,.18)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginBottom: "12px",
              }}
            >
              <div
                style={{
                  width: "34px",
                  height: "34px",
                  background: "#fee2e2",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--danger)",
                }}
              >
                <i className="pi pi-trash"></i>
              </div>
              <h6 style={{ margin: 0, fontWeight: 700 }}>Delete Claim</h6>
            </div>

            <p
              style={{
                fontSize: "13px",
                color: "var(--text-mid)",
                margin: "0 0 18px",
              }}
            >
              Delete reimbursement claim for {deleteRecord?.EmployeeName} (
              {deleteRecord?.ReimbursementTypeName}, {rup(deleteRecord?.Amount)}
              )?
            </p>

            <div
              style={{
                display: "flex",
                gap: "8px",
                justifyContent: "flex-end",
              }}
            >
              <button
                className="btn btn-light"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-brand"
                style={{
                  background: "var(--danger)",
                  borderColor: "var(--danger)",
                }}
                onClick={confirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReimbursementManagement;
